import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { I18n } from 'utils/i18n';
import { func, object } from 'prop-types';

import SelectTitle from '../SelectTitle';
import BrowserItem from '../BrowserItem';

const BrowserNotifications = ({ settings, onChange }) => {
  const handleChange = useCallback(
    (name, value) => {
      const newVal = {};
      newVal[name] = value;
      onChange({ ...settings, ...newVal });
    },
    [settings, onChange],
  );

  return (
    <Box sx={{ pr: '20px', mb: '10px' }}>
      <SelectTitle headline={I18n.t('SettingsDrawer.Computer_Notifications')} />

      {Object.entries(settings).map(([name, value]) => (
        <BrowserItem
          headline={I18n.t(`SettingsDrawer.${name}`)}
          key={name}
          enabled={value}
          onClick={val => handleChange(name, val)}
        />
      ))}
    </Box>
  );
};

BrowserNotifications.propTypes = {
  settings: object.isRequired,
  onChange: func.isRequired,
};

export default BrowserNotifications;
